import { AxiosError } from "axios"
import { logout } from "./system"
import { NormalException } from "./type"

// 全局错误处理函数
export default function (err: any, vm: any, info: any) {
  $util.loading(false)  // 关闭加载中
  const result = handleError(err)    // 异常处理
  result || console.error(err)      // 控制台抛出
}

function handleError(err: any): boolean | undefined {
  // 如果是axios请求异常，则根据请求的响应码，做对应的处理
  if (err instanceof AxiosError) {
    switch (err.response?.status) {
      case 401:     // 未登录异常
        $util.modal.destroyAll()
        $util.modal.warning({
          title: '提醒',
          content: '用户登录超时，请重新登录！',
          onOk: logout
        })
        return true
      default:
        $util.message.error({
          content: err.message
        })
        break
    }
    return
  } else if (err instanceof NormalException) {
    // 如果是手动抛出的普通异常，则使用消息提示
    $util.message.error({
      content: err.message, duration: 3
    })
    return true
  } else if (err.errorFields && err.errorFields.length > 0) {
    // 表单验证错误
    $util.message.error({
      content: err.errorFields[0].errors[0]
    })
    return true
  }

  // 其他未处理异常，在右下角提示
  $util.notify.error({
    message: '系统错误，请联系管理员', placement: 'bottomRight', duration: 3
  })
}
